import { render, staticRenderFns } from "./ChildItemLink.vue?vue&type=template&id=443b5660&"
import script from "./ChildItemLink.vue?vue&type=script&lang=js&"
export * from "./ChildItemLink.vue?vue&type=script&lang=js&"
import style0 from "./ChildItemLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports